<script>
  /* Executable code section of the program */
  //Tools importation
  import { isEmptyChatBox } from "../../apis/storage";

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="principalContent">
  <div class="bodyContent">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      fill="currentColor"
      class="bi bi-person-lines-fill"
      viewBox="0 0 16 16"
    >
      <path
        d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
      />
    </svg>
    <p>To display a chat, select it from the list.</p>
  </div>
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .principalContent {
    width: 60%;
    height: 90%;
  }
  .bodyContent {
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px;
  }
  p {
    margin: 10px;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
  }

  /* End of the section */
</style>
